module.exports = __webpack_public_path__ + "media/images/ceremony/top/plan/plan-detail-background-bfe08ea312d12d6d20e324edca261a57.jpg";